import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../../constants';
import { BuiltinInstanceMemberCall } from '../../BuiltinInstanceMemberCall';
export class SetStorageAdd extends BuiltinInstanceMemberCall {
    canCall(_sb, _func, node) {
        return tsUtils.argumented.getArguments(node).length === 1;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        if (tsUtils.argumented.getArguments(node).length < 1) {
            return;
        }
        const key = tsUtils.argumented.getArguments(node)[0];
        const keyType = sb.context.analysis.getType(key);
        if (optionsIn.pushValue) {
            sb.emitOp(node, 'DUP');
        }
        sb.visit(key, options);
        sb.emitPushBoolean(node, true);
        sb.emitHelper(node, optionsIn, sb.helpers.setStructuredStorage({ type: Types.SetStorage, keyType }));
    }
}

//# sourceMappingURL=add.js.map
